module.exports = __webpack_public_path__ + "static/media/eleventh_city_hall4.fe6a82aa.png";